'use client';

import style from './Header.module.scss';
import Link from 'next/link';
// import Image from 'next/image';
// import { useState } from 'react';
import Avatar from '@/components/ui/avatar/Avatar';
import { useRouter } from 'next/navigation';
import { useAppDispatch } from '@/store/hook';
import { useAppSelector } from '@/store/hook';
import { DEFAULT_AVATAR } from '@/constants/image';
import { startGlobalLoading, stopGlobalLoading } from '@/features/ui/uiLoadingSlice';
import { AuthService } from '@/libs/services/auth';
// import { SideSheet } from '@/components/ui/sideSheet/SideSheet';
// import CreateBusiness from '@/app/store/[storeId]/(public)/CreateBusiness';
//libs
// import { Stores } from '@/libs/api/stores';
// icons
import {
  IconEditOutline,
  // IconLucidePlus,
  // IconRecordHistoryOutline,
  // IconHelpCircleOutline,
  IconLogOutOutline,
  // IconQRcode,
  IconFriends,
  // IconChat,
  IconGiftSolid,
  IconLogin,
  // IconCoinEmoji,
  // IconIncome,
  // IconSetting,
  // IconLogin,
  // IconExchangeCoin,
} from '@/components/icons';

const HeaderMenuMoreDropdown = () => {
  const router = useRouter();
  const meInfo = useAppSelector((state) => state.auth.meInfo);
  const dispatch = useAppDispatch();
  // const [showAccountList, setShowAccountList] = useState(false);

  // const handleSwitchAccount = () => {
  //   setShowAccountList(true);
  // };

  // const handleBackToInfo = () => {
  //   setShowAccountList(false);
  // };

  return (
    <div
      className="dropdown-menu dropdown-menu-more py-2"
      data-bs-theme="light"
      style={{ display: 'block', position: 'absolute', right: 0, top: '105%', width: '320px' }}
    >
      <div className={style.menuContainer}>
        <div className={`${style.menuContainerInner} `}>
          {/* 主帳戶資訊頁 */}
          <div className={style.menuPanel}>
            <div className="dropdown-menu-more-my-info">
              {meInfo ? (
                <div className="dropdown-item-user align-items-start p-2 pb-0">
                  <Link href={meInfo ? `/user/${meInfo.womo_id}` : '/auth/login'}>
                    <span className={style.avatar}>
                      <Avatar src={meInfo?.u_photo ?? DEFAULT_AVATAR} size={40} />
                    </span>
                  </Link>

                  <span className="txt ms-2">
                    <span className="fw-bold d-block">{meInfo?.name ?? '訪客'}</span>
                    {meInfo ? (
                      <p className="fs-xs text-muted">開始探索社交亮點</p>
                    ) : (
                      // <button
                      //   className="btn-switch-account fs-sm-1 text-grey"
                      //   onClick={handleSwitchAccount}
                      // >
                      //   品牌專頁管理
                      //   <i className="bi bi-chevron-right"></i>
                      // </button>
                      <Link className="fs-sm-1 text-grey" href={'auth/login'}>
                        登入會員
                      </Link>
                    )}
                  </span>
                </div>
              ) : null}

              <ul>
                {meInfo ? (
                  <>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <Link href="/me/profile/edit" className="dropdown-item">
                        <span className="icon fw-bold">
                          <IconEditOutline width={19} />
                        </span>
                        <span className="txt">我的小檔案</span>
                      </Link>
                    </li>

                    <li>
                      <Link href="/me/coin-friends" className="dropdown-item">
                        <span className="icon">
                          <IconFriends width={18} />
                        </span>
                        <span className="txt">我的籌碼友</span>
                      </Link>
                    </li>
                    <li>
                      <Link href="/me/coupon" className="dropdown-item">
                        <span className="icon">
                          <IconGiftSolid width={18} />
                        </span>
                        <span className="txt">我的禮物券</span>
                      </Link>
                    </li>
                  </>
                ) : (
                  <li>
                    <Link href="/auth/login" className="dropdown-item">
                      <span className="icon">
                        <IconLogin width={18} />
                      </span>
                      <span className="txt">登入會員</span>
                    </Link>
                  </li>
                )}
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link href="/help" className="dropdown-item">
                    <span className="txt">說明中心</span>
                  </Link>
                </li>
                <li>
                  <Link href="/terms/privacy-policy" className="dropdown-item">
                    <span className="txt">隱私權設定</span>
                  </Link>
                </li>
                <li>
                  <Link href="/terms/services" className="dropdown-item">
                    <span className="txt">會員條款</span>
                  </Link>
                </li>

                {meInfo ? (
                  <>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <button
                        type="button"
                        className="dropdown-item px-5 d-flex align-items-center"
                        onClick={async () => {
                          dispatch(startGlobalLoading());
                          await new Promise((resolve) => setTimeout(resolve, 1000));
                          AuthService.handleLogout(dispatch);
                          dispatch(stopGlobalLoading());
                          router.push('/');
                        }}
                      >
                        <span className="icon">
                          <IconLogOutOutline width={18} />
                        </span>
                        <span className="txt ms-1">登出</span>
                      </button>
                    </li>
                  </>
                ) : null}
                {/* <li>
                  <Link href="/me/profile-red-coin" className="dropdown-item">
                    <span className="icon">
                      <IconChat width={18} />
                    </span>
                    <span className="txt">我的私聊房</span>
                  </Link>
                </li> */}
                {/* 
                <li>
                  <Link href="/me/promote-card" className="dropdown-item">
                    <span className="icon">
                      <IconQRcode width={18} />
                    </span>
                    <span className="txt">我的推廣碼</span>
                  </Link>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>

                <li>
                  <Link href="/me/profile-green-coin" className="dropdown-item">
                    <span className="icon">
                      <IconCoinEmoji width={20} />
                    </span>
                    <span className="txt">我的綠籌碼</span>
                  </Link>
                </li>
                <li>
                  <Link href="/me/profile-red-coin" className="dropdown-item">
                    <span className="icon">
                      <IconCoinEmoji width={20} />
                    </span>
                    <span className="txt">我的紅籌碼</span>
                  </Link>
                </li>

                <li>
                  <Link href="/me/coin-subscribe" className="dropdown-item">
                    <span className="icon">
                      <IconExchangeCoin width={20} />
                    </span>
                    <span className="txt">我的訂閱</span>
                  </Link>
                </li>
                <li>
                  <Link href="/me/coin-income" className="dropdown-item">
                    <span className="icon">
                      <IconIncome width={20} />
                    </span>
                    <span className="txt">我的收益</span>
                  </Link>
                </li> */}
                {/* <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link href="/me/badge-business" className="dropdown-item">
                    <span className="icon">
                      <IconCheckBadge width={16} color="#00b0b4" />
                    </span>
                    <span className="txt">綠勾勾商業帳號</span>
                  </Link>
                </li>
                <li>
                  <Link href="/me/badge-womer" className="dropdown-item">
                    <span className="icon">
                      <IconCheckBadge width={16} color="#da5271" />
                    </span>
                    <span className="txt">紅勾勾 WoMer</span>
                  </Link>
                </li>
                <li>
                  <Link href="/" className="dropdown-item">
                    <span className="icon">
                      <IconCheckBadge width={16} color="#e3bc41" />
                    </span>
                    <span className="txt">金勾勾榮耀標章</span>
                  </Link>
                </li> */}
                {/* <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link href="/deposit/record" className="dropdown-item">
                    <span className="icon">
                      <IconRecordHistoryOutline />
                    </span>
                    <span className="txt">儲值紀錄</span>
                  </Link>
                </li>
                <li>
                  <Link href="/help" className="dropdown-item">
                    <span className="icon">
                      <IconHelpCircleOutline />
                    </span>
                    <span className="txt">幫助中心</span>
                  </Link>
                </li>
                <li>
                  <Link href="/me/account-setting">
                    <span className="icon">
                      <IconSetting width={21} />
                    </span>
                    <span className="txt">帳號設定</span>
                  </Link>
                </li> */}

                {/*<li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconUserProfile />
                    </span>
                    <span className="txt">個人資料</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconEmojiOutline />
                    </span>
                    <span className="txt">回謝卡</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconGetBoxOutline />
                    </span>
                    <span className="txt">抖內箱</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconGiftOutline />
                    </span>
                    <span className="txt">群發送禮</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconFluentMoneyOutline />
                    </span>
                    <span className="txt">儲值</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconRankOutline />
                    </span>
                    <span className="txt">排行榜</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconCartOutline />
                    </span>
                    <span className="txt">WoMall</span>
                  </Link>
                </li>
                <li>
                  <Link href="#" className="dropdown-item">
                    <span className="icon">
                      <IconGuideOutline />
                    </span>
                    <span className="txt">平台攻略</span>
                  </Link>
                </li>*/}
              </ul>
            </div>
          </div>

          {/* 切換帳號頁 */}
          {/* <div className={style.menuPanel}>
            <div className="dropdown-menu-more-my-account">
              <div className="p-2 pb-0">
                <button onClick={handleBackToInfo}>
                  <span className="icon">
                    <i className="bi bi-chevron-left"></i>
                  </span>
                  <span className="txt ms-2">返回帳戶選單</span>
                </button>
              </div>

              <ul className="">
                <li>
                  <hr className="dropdown-divider" />
                </li>
                {Stores.slice(0, 3).map((store, index) => (
                  <li key={index}>
                    <Link
                      href="/store/TOkB7LSnFO1/manager"
                      className="dropdown-item-user align-items-center"
                    >
                      <span className={style.avatar}>
                        <Image
                          src={store.image}
                          alt={store.name}
                          width={40}
                          height={40}
                          className="rounded-circle"
                        />
                      </span>
                      <span className="fw-bold txt ms-2">{store.name}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <SideSheet
                    side="bottom"
                    vh={75}
                    title="創建品牌專頁"
                    titleHidden
                    trigger={
                      <div className="dropdown-item">
                        <span className="icon fw-bold">
                          <IconLucidePlus width={20} />
                        </span>
                        <span className="txt">創建我的品牌專頁</span>
                      </div>
                    }
                  >
                    <CreateBusiness />
                  </SideSheet>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default HeaderMenuMoreDropdown;
